module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-2-img-sp_9c16477d4d0b382fbd9292448a3daf73.png";